import React, { useState } from 'react'


import { makeStyles } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'

import settings from 'settings'

const MenuIcon = settings.icons.menu

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  list: {
    width: settings.sideMenuWidth,
  },
}))

const SideMenu = ({
  items,
  openPage,
}) => {

  const classes = useStyles()
  const [ drawerOpen, setDrawerOpen ] = useState(false)

  const handleOpen = event => setDrawerOpen(true)
  const handleClose = () => setDrawerOpen(false)

  const clickItem = (item) => {
    if(typeof(item.handler) === 'string') {
      openPage(item.handler)
      handleClose()
    }
    else if(item.handler.constructor === Array) {
      const [ route, params ] = item.handler
      openPage(route, params)
      handleClose()
    }
    else if(typeof(item.handler) === 'function') {
      item.handler()
      handleClose()
    }
    else {
      throw new Error(`unknown SideMenu item handler for ${item.title}`)
    }
  }

  return (
    <div>
      <IconButton 
        className={classes.menuButton} 
        color="inherit" 
        aria-label="Menu" 
        onClick={ handleOpen }
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        open={ drawerOpen }
        onClose={ handleClose }
        onOpen={ handleOpen }
      >
        <div
          tabIndex={0}
          role="button"
          onClick={ handleClose }
          onKeyDown={ handleClose }
        >
          <div className={classes.list}>
            <List component="nav">
              {
                items.map((item, i) => {
                  if(item === '-') {
                    return (
                      <Divider key={ i } />
                    )
                  }
            
                  return (
                    <ListItem 
                      button 
                      key={ i }
                      onClick={ () => clickItem(item) }
                    >
                      {
                        item.icon && (
                          <ListItemIcon>
                            <item.icon />
                          </ListItemIcon>
                        )
                      }
                      <ListItemText 
                        primary={ item.title }
                      />
                    </ListItem>
                  )
                })
              }
            </List>
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  )
  
}

export default SideMenu